<template>
  <div>
    <div class="jss634">
      <div class="MuiContainer-root jss638 MuiContainer-maxWidthMd">
        <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
          <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
            <div class="MuiBox-root jss645 jss635 null">
              <div style="height: 100%; width: 100%;">
                <div class="jss646">
                   <div style="position: relative; padding-top: 100%;" v-if="work.workType == 'video'">
                      <iframe :src="work.work" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; object-fit: fill;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true">
                      </iframe>
                    </div>
                  <div v-if="work.workType == 'image'">
                    <img :src="work.work" alt="" class="jss648 jss659"  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="MuiContainer-root MuiContainer-maxWidthMd mt-8">
        <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
          <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
            <div class="fs-18 fw-700 mb-4">
              {{work.nft}}
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Artist</div>
              <div class="rainbow_txt_underline">
                <router-link :to="'/artsit/' + work.author.toLowerCase().replace(' ', '')">
                  {{work.author}}
                </router-link>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Series</div>
              <div class="rainbow_txt_underline">
                  <a href="/#today">{{work.series}}</a>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Collection</div>
              <div class="rainbow_txt_underline">
                <a href="https://solsea.io/collection/620885aa80d5844492bb7e6a" target="_blank">{{work.collection}}</a>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-4">
              <div>{{ work.sold ? 'SOLD' : 'Current price' }}</div>
              <div><span class="sol fs-14 mr-1">Ⓞ</span>{{work.solValue}} <span v-if="currentPrice > 0">({{ '$' + this.$tools.formatNumber(currentPrice.toFixed(2)) }})</span> </div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-4">
              <div>Owned by</div>
              <div class="rainbow_txt_underline">
                <a :href="'https://explorer.solana.com/address/' + work.ownedBy" target="_blank"
                  rel="noopener noreferrer"
                  class="del-underline">{{ work.ownedBy.substring(0,6) + "..." + work.ownedBy.substring(work.ownedBy.length - 4)  }}
                  &#8599;</a>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-center mt-4">
              <a :href="'https://solsea.io/nft/' + work.contractAdress" target="_blank" rel="noopener noreferrer"
                class="del-underline">
                <v-btn class="jss80 t-none" width="260">Buy now</v-btn>
              </a>
            </div>
            <div class="fs-18 mt-4" :class="[work.sold ? '' : 'mb-100']">
              Price history
            </div>
            <!-- 价格图表 -->
            <div class="fs-18 mt-4" v-if="work.sold">
             <price-history-chart :title="work.title"></price-history-chart>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-4">
              <div>Contract Address</div>
              <div class="rainbow_txt_underline">
                <a :href="'https://explorer.solana.com/address/' + work.contractAdress" target="_blank"
                  rel="noopener noreferrer"
                  class="del-underline">{{ work.contractAdress.substring(0,6) + "..." + work.contractAdress.substring(work.contractAdress.length - 4)  }}
                  &#8599;</a>
              </div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Token ID</div>
              <div>{{work.tokenId}}</div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Token Standard</div>
              <div>{{work.tokenStandard}}</div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Blockchain</div>
              <div>{{work.blockchain}}</div>
            </div>
            <div class="fs-18 mt-4">
              Original Artwork
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Size</div>
              <div>{{work.size}}</div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Material</div>
              <div>{{work.material}}</div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Year</div>
              <div>{{work.year}}</div>
            </div>
            <div class="d-flex flex-wrap justify-space-between mt-2">
              <div>Collected by</div>
              <div class="text-ellipsis">{{work.collectedBy}}</div>
            </div>
            <div class="fs-18 mt-4" v-if="work.descType == 'description'">
              <div>
                The story behind this artwork:
              </div>
              <div class="mt-2">
                {{work.description}}
              </div>
              <div class="mt-4">
                {{work.description1}}
              </div>
            </div>
            <div class="fs-18 mt-4" v-if="work.descType == 'shortDescription'">
              <div>
                About
              </div>
              <div class="mb-2 mt-2">
                {{work.shortDesc}}
              </div>
              <div class="mb-2">
                {{work.desc}}
              </div>
              <div class="mb-2">
                {{work.material}}
              </div>
              <div class="mb-2">
                {{work.size}}
              </div>
              <div class="mb-2">
                {{work.year}}
              </div>
              <div class="mb-2">
                {{work.collectedBy}}
              </div>
              <div class="mb-2">
                {{work.copyright}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="MuiContainer-root jss100 MuiContainer-maxWidthMd">
        <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
          <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
            <div class="d-flex flex-wrap justify-space-between">
              <!-- 上一页 -->
              <div>
                <div v-if="workIndex > 0" class="pointer" @click="changeWork(workIndex - 1)">
                  <v-icon size="24" class="mb-1">mdi-chevron-left</v-icon>
                  <span class="blue--text">{{ workList[workIndex - 1].nft }}</span>
                </div>
              </div>
              <!-- 下一页 -->
              <div>
                <div v-if="workIndex < workList.length - 1" class="pointer" @click="changeWork(workIndex + 1)">
                  <span class="blue--text">{{ workList[workIndex + 1].nft }}</span>
                  <v-icon size="24" class="mb-1">mdi-chevron-right</v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import PriceHistoryChart from "./charts/PriceHistoryChart.vue"
  import SolLogo from '@/components/SolLogo'
  import trc from "./data/trc.json"
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        title: this.$route.params.title,
        workList: trc,
      }
    },
    components: {
      SolLogo,
      PriceHistoryChart
    },
    created() {

    },
    mounted() {

    },
    computed: {
      ...mapGetters(["solPrice"]),
      work() {
        let work = this.workList.filter(work => work.title == this.title)[0];
        return work == null ? {} : work;
      },
      workIndex() {
        return this.workList.findIndex((work, index) => work.title == this.title);
      },
      // 当前价格
      currentPrice(){
        return this.work.solValue * this.solPrice;
      }
    },
    watch: {
      title(newVal, oldVal) {

      },
      $route() {
        this.title = this.$route.params.title
      },
    },
    methods: {
      changeWork(index){
        this.$router.push({ name: 'Collection', params: { title: this.workList[index].title } });
      },
    },
  }
</script>
<style lang="scss" scoped>
  .sol {
    color: var(--blue);
  }
</style>



// WEBPACK FOOTER //
// src/views/artist/Collection.vue